/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { WalletV2 } from "./WalletV2";
import * as t from "io-ts";

// required attributes
const WalletV2ListResponseR = t.interface({});

// optional attributes
const WalletV2ListResponseO = t.partial({
  data: t.readonlyArray(WalletV2, "array of WalletV2")
});

export const WalletV2ListResponse = t.intersection(
  [WalletV2ListResponseR, WalletV2ListResponseO],
  "WalletV2ListResponse"
);

export type WalletV2ListResponse = t.TypeOf<typeof WalletV2ListResponse>;
